import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../../../hooks';
import './Content.scss';
export const Content = ({ children, defaultPadding }) => {
    const className = useClassName({ name: 'card-content', prefixed: true }, defaultPadding && 'default-padding');
    return _jsx("div", { className: className, children: children });
};
